import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "template_estate-statistics fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdStatisticsList = _resolveComponent("AdStatisticsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdStatistics.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AdStatistics.agency-ads')), 1),
              _createVNode(_component_AdStatisticsList, { statistics: _ctx.estateAgencyStatistics }, null, 8, ["statistics"]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('AdStatistics.my-ads')), 1),
              _createVNode(_component_AdStatisticsList, { statistics: _ctx.userStatistics }, null, 8, ["statistics"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}